import { render, staticRenderFns } from "./ProjectTypesModal.vue?vue&type=template&id=678fc4aa&scoped=true&"
import script from "./ProjectTypesModal.vue?vue&type=script&lang=js&"
export * from "./ProjectTypesModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTypesModal.vue?vue&type=style&index=0&id=678fc4aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678fc4aa",
  null
  
)

export default component.exports